import { KeyboardEventHandler, useEffect, useState } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';

import styled from 'styled-components';

import CoreGrayButton from 'shared/button/CoreGrayButton';
import CoreImg from 'shared/CoreImg';
import CoreSearchInput from 'shared/input/CoreSearchInput';
import style from 'styles/styled-components/style';
import { removeCookie } from 'utils/cookies';

import { nav_list } from './data';

const Header = () => {
	const navigate = useNavigate();
	const [searchParams, setSearchParams] = useSearchParams();
	const { platform } = useParams();
	const [keyword, setKeyword] = useState(searchParams.get('keyword') ?? '');

	useEffect(() => {
		setKeyword(searchParams.get('keyword') ?? '');
	}, [searchParams.get('keyword')]);

	const logout = () => {
		sessionStorage.removeItem('wconcept_user_type');
		removeCookie('Authorization');
		navigate('/login');
	};

	const onKeyDownEvent: KeyboardEventHandler<HTMLInputElement> = (e) => {
		if (e.key === 'Enter') {
			//동일한 url에 keyword 적용
			searchParams.set('keyword', keyword);
			setSearchParams(searchParams);
		}
	};

	// URL에 "report"가 포함되어 있는지 확인
	const isReportPage = location.pathname.includes('/report');

	return (
		<HeaderBox>
			<Grid flex="start" _gap="16px">
				<Grid _width="110px" _height="14px">
					<img src="/wconcept_logo.png" alt="logo" width={110} />
				</Grid>
				<Text typo="h4">
					{nav_list.find((item) => location.pathname.includes(item.include))?.header}
				</Text>
			</Grid>

			{/* {!isReportPage && (
				<Grid>
					<CoreSearchInput
						input_id="total-search-button"
						_width="640px"
						_value={keyword}
						_onChange={(e) => setKeyword(e.currentTarget.value)}
						_onKeyDown={onKeyDownEvent}
						_placeholder={`계정명을 입력해주세요.`}
					/>
				</Grid>
			)} */}

			<Grid flex="end">
				<CoreGrayButton
					size="default"
					style_type="outlined"
					text="로그아웃"
					color_type="default"
					_onClick={logout}
				/>
			</Grid>
		</HeaderBox>
	);
};

const { Text, Grid } = style;

const HeaderBox = styled.header`
	width: 100%;
	height: 76px;
	padding: 24px 16px;

	${({ theme }) => theme.common.flexBetween};
	gap: 16px;
	color: ${({ theme }) => theme.colors.gray.gray70};
	border-bottom: 1px solid ${({ theme }) => theme.colors.gray.gray15};
`;

export default Header;
